import React from 'react';
import MultiFilter from './MultiFilter.js';
import SoftClipperComponent from './SoftClipperComponent.js';
import GainComponent from './GainComponent.js';
import GranulatorComponent from './GranulatorComponent.js';
import OscilloscopeComponent from './OscilloscopeComponent.js';
import GateEffect from './GateEffect.js';
import GranularComponent from './GranularComponent.js';
import GeneticWaveShaperComponent from './GeneticWaveShaperComponent.js';
import PanningComponent from './PanningComponent.js';
import FilterEffect from './FilterEffect.js';
import AutoFilterEffect from './AutoFilterEffect.js';
import ReverbEffect from './ReverbEffect.js';
import FreakShifterComponent from './FreakShifterComponent.js';
import ConvolverReverbEffect from './ConvolverReverbEffect.js';
import ChorusEffect from './ChorusEffect.js';
import TremoloEffect from './TremoloEffect.js';
import TransientShaperComponent from './TransientShaperComponent.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {getInstrumentComponent} from './getInstrumentComponent.js';
import InstrumentRackComponent from 'components/instruments/InstrumentRackComponent.js';
import DelayEffect from './DelayEffect.js';
import CompressorEffect from './CompressorEffect.js';
import ChebyshevEffect from './ChebyshevEffect.js';
import EQ3Effect from './EQ3Effect.js';
import EQ10Effect from './EQ10Effect.js';
import MultibandCompressorEffect from './MultibandCompressorEffect.js';
import UltraPhaserEffect from './UltraPhaserEffect.js';
import AutoWahEffect from './AutoWahEffect.js';
import DistortionEffect from './DistortionEffect.js';
import BitCrusherEffect from './BitCrusherEffect.js';
import SaturatorEffect from './SaturatorEffect.js';
import PitchShift from './PitchShift.js';
import PannerEffect from './PannerEffect.js';
import FollowerComponent from './FollowerComponent.js';
import VocoderComponent from './VocoderComponent.js';
import FrequencyAnalyserEffect from './FrequencyAnalyserEffect.js';
import StereoWidenerEffect from './StereoWidenerEffect.js';
import TapeDelayComponent from './TapeDelayComponent.js';
import StereoDelayComponent from './StereoDelayComponent.js';
import EffectRackComponent from './EffectRackComponent.js';
import WaveFolder2Component from './WaveFolder2Component.js';
import GuitarAmpComponent from './GuitarAmpComponent.js';
import WaveFolderComponent from './WaveFolderComponent.js';
import RingModulatorComponent from './RingModulatorComponent.js';
import FrequencyShifter from './FrequencyShifter.js';

export const getEffect = (props) => {
    if (props.effect.name === 'Filter') {
        return (
            <FilterEffect
              {... props}
              effectNumber={props.effectNumber}
              sequencerEngine={props.sequencerEngine}
              automation={props.automation}
              selectedParameter={props.selectedParameter}
              onEffectsChange={props.onEffectsChange}
              onParameterChanged={props.onParameterChanged}
              filterEffect={props.effect}/>
        );
        } else if (props.effect.name === 'Auto Filter') {
            return (
                <AutoFilterEffect
                    {... props}
                    sequencerEngine={props.sequencerEngine}
                    effectNumber={props.effectNumber}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    filterEffect={props.effect}/>
            );
        } else if (props.effect.name === 'Gain') {
            return (
                <GainComponent
                    {... props}
                    sequencerEngine={props.sequencerEngine}
                    effectNumber={props.effectNumber}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    filterEffect={props.effect}/>
            );
        } else if (props.effect.name === 'Delay') {
            return (
                <DelayEffect
                    {... props}
                    effectNumber={props.effectNumber}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    delayEffect={props.effect}/>
            );
        } else if (props.effect.name === 'Tremolo') {
            return (
                <TremoloEffect
                    {... props}
                    effectNumber={props.effectNumber}
                    automation={props.automation}
                    sequencerEngine={props.sequencerEngine}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    tremoloEffect={props.effect}/>
            );
        } else if (props.effect.name === 'Chorus') {
            return (
                <ChorusEffect
                    {... props}
                    effectNumber={props.effectNumber}
                    automation={props.automation}
                    sequencerEngine={props.sequencerEngine}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    chorusEffect={props.effect}/>
            );
        } else if (props.effect.name === 'Reverb') {
            return (
                <ReverbEffect
                    {... props}
                    effectNumber={props.effectNumber}
                    automation={props.automation}
                    sequencerEngine={props.sequencerEngine}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    reverbEffect={props.effect}/>
            );
        } else if (props.effect.name === 'Convolver Reverb') {
            return (
                <ConvolverReverbEffect
                  {... props}
                    effectNumber={props.effectNumber}
                    automation={props.automation}
                    sequencerEngine={props.sequencerEngine}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    reverbEffect={props.effect}/>
            );
        } else if (props.effect.name === 'Compressor') {
            return (
                <CompressorEffect
                    {... props}
                    effectNumber={props.effectNumber}
                    automation={props.automation}
                    sequencerEngine={props.sequencerEngine}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Distortion') {
            return (
                <DistortionEffect
                    {... props}
                    sequencerEngine={props.sequencerEngine}
                    effectNumber={props.effectNumber}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'EQ 3') {
            return (
                <EQ3Effect
                    {... props}
                    sequencerEngine={props.sequencerEngine}
                    effectNumber={props.effectNumber}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'EQ 10') {
            return (
                <EQ10Effect
                    {... props}
                    sequencerEngine={props.sequencerEngine}
                    effectNumber={props.effectNumber}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Bit Crusher') {
            return (
                <BitCrusherEffect
                    {... props}
                    effectNumber={props.effectNumber}
                    automation={props.automation}
                    sequencerEngine={props.sequencerEngine}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Ultra Phaser') {
            return (
                <UltraPhaserEffect
                    {... props}
                    effectNumber={props.effectNumber}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    sequencerEngine={props.sequencerEngine}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Multi Filter') {
            return (
                <MultiFilter
                    {... props}
                    effectNumber={props.effectNumber}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    sequencerEngine={props.sequencerEngine}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Auto Wah') {
            return (
                <AutoWahEffect
                    {... props}
                    effectNumber={props.effectNumber}
                    automation={props.automation}
                    sequencerEngine={props.sequencerEngine}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Granular') {
            return (
                <GranularComponent
                    {... props}
                    effectNumber={props.effectNumber}
                    automation={props.automation}
                    sequencerEngine={props.sequencerEngine}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        }  else if (props.effect.name === 'Gate') {
            return (
                <GateEffect
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Pitch Shift') {
            return (
                <PitchShift
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Panner') {
            return (
                <PannerEffect
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'EQ8') {
            return (
                <FrequencyAnalyserEffect
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Chebyshev') {
            return (
                <ChebyshevEffect
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Multiband Compressor') {
            return (
                <MultibandCompressorEffect
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Stereo Widener') {
            return (
                <StereoWidenerEffect
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Saturator') {
            return (
                <SaturatorEffect
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Soft Clipper') {
            return (
                <SoftClipperComponent
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Tape Delay') {
            return (
                <TapeDelayComponent
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Stereo Delay') {
            return (
                <StereoDelayComponent
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Oscilloscope') {
            return (
                <OscilloscopeComponent
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Effect Rack') {
            return (
                <EffectRackComponent
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Guitar Amp') {
            return (
                <GuitarAmpComponent
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Wave Folder') {
            return (
                <WaveFolderComponent
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Wave Folder 2') {
            return (
                <WaveFolder2Component
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Granulator') {
            return (
                <GranulatorComponent
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Ring Modulator') {
            return (
                <RingModulatorComponent
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Follower') {
            return (
                <FollowerComponent
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Vocoder') {
            return (
                <VocoderComponent
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Frequency Shifter') {
            return (
                <FrequencyShifter
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Transient Shaper') {
            return (
                <TransientShaperComponent
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Genetic WaveShaper') {
            return (
                <GeneticWaveShaperComponent
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else if (props.effect.name === 'Freak Shifter') {
            return (
                <FreakShifterComponent
                    {... props}
                    effectNumber={props.effectNumber}
                    tracks={props.tracks}
                    sequencerEngine={props.sequencerEngine}
                    automation={props.automation}
                    selectedParameter={props.selectedParameter}
                    onEffectsChange={props.onEffectsChange}
                    onParameterChanged={props.onParameterChanged}
                    effect={props.effect}/>
            );
        } else {
            return null;
        }
};
